import { Asset, PanelIntent, PanelView } from 'modules/creativeLibrary';
import { MediumDataKey } from 'modules/templateEditor/common';
import { DataFeed, NewDataFeed } from 'modules/dataFeeds/types';

// Template Editor

export enum ContentModals {
  CopyTemplate = 'copyTemplate',
  CreativeLibrary = 'creativeLibrary',
  DisplayTestMessage = 'displayTestMessage',
  InsertSnippet = 'insertSnippet',
}

export type InsertSnippetModalType = {
  modal: ContentModals;
  mediumDataKey: MediumDataKey;
  mediumDataValue: string;
  mediumRef?: any;
};

export type CopyTemplateModalType = {
  modal: ContentModals;
  showCopyModal: string;
};

export type CreativeLibraryPanelType = {
  initView?: PanelView;
  intent?: PanelIntent;
  modal: ContentModals;
  onSelect?: (url: string) => void;
  selectedAssetData?: Asset;
};

export type MovableInkPanelType = {
  intent?: PanelIntent;
  modal: ContentModals;
  onSelect?: (url: string) => void;
};

export type EmbeddedDisplayTestMessageType = {
  modal: ContentModals;
};

export type ContentModalStateType =
  | InsertSnippetModalType
  | CopyTemplateModalType
  | CreativeLibraryPanelType
  | EmbeddedDisplayTestMessageType
  | MovableInkPanelType;

// Data Feeds

export enum DataFeedsModals {
  ConfirmDelete = 'data-feeds-modal/confirm-delete',
  CreateFeed = 'data-feeds-modal/create-feed',
  EditAlias = 'data-feeds-modal/edit-alias',
  EditFeed = 'data-feeds-modal/edit-feed',
}

export type DataFeedsModalConfirmDelete = {
  modal: DataFeedsModals;
  dataFeed: DataFeed;
};

export type DataFeedsModalCreateFeed = {
  modal: DataFeedsModals;
  dataFeed: NewDataFeed;
};

export type DataFeedsModalEditAlias = {
  modal: DataFeedsModals;
  dataFeed: DataFeed;
};

export type DataFeedsModalEditFeed = {
  modal: DataFeedsModals;
  dataFeed: DataFeed;
};

export type DataFeedsModalStateType =
  | DataFeedsModalConfirmDelete
  | DataFeedsModalCreateFeed
  | DataFeedsModalEditAlias
  | DataFeedsModalEditFeed;
